import React from 'react'; 
import { Load, Success, DeleteItem, SearchBar } from './partials/PopUps.js';
import { toast } from 'react-toastify';
const Items = (props) => {
	const { sucursales, onRemoveItem, openmodal, openModalView, sesion } = props;
	let lista = [];
	sucursales.forEach((sucursal, index)=>
		lista.push(
			<tr key={index}>
				<td className="sucursal">{sucursal.nombre}</td>
				<td className="tipo">{sucursal.telefono}</td>
				<td className="tipo">{sucursal.direccion}</td>
				<td className="operaciones">
					<span className="icon-view" onClick={()=>openModalView(sucursal.id)}></span>
					{ sesion.rol=== 1 && <span className="icon-pencil" onClick={()=>openmodal(sucursal.id)}></span>}
					{ ( sesion.rol=== 1 && sucursal.nombre !== 'Bodega' ) && <span className="icon-trash" onClick={()=>onRemoveItem(sucursal.id)}></span>}
					{ ( sesion.rol=== 1 && sucursal.nombre === 'Bodega' ) && <span className="icon-trash disabled"></span>}
				</td>
			</tr>
		)
	);
	return <tbody>{lista}</tbody>;
}
const Info = (props) => {
	const { closeModal, sucursal, display} = props;
	return(
		<div className={ display ? 'overlay show' : 'overlay'}>
			<div className="content">
				<div className="modal_header">
					<h5>DETALLE</h5>
					<span className="close-pop-up" onClick={closeModal}>x</span>
				</div>
				<div className="modal_body">
					<p><strong>Sucursal: </strong>{sucursal.nombre}</p>
					
					<p><strong>Teléfono: </strong>{sucursal.telefono}</p>
					<p><strong>Encabezado para ticket: </strong>{sucursal.direccion}</p>
				</div>
			</div>
		</div>
	);
}
class Sucursal extends React.Component{
	constructor(props){
		super(props);
		this.state = { 
			openModal : false,
			display : {
				delete : false,
				load : false,
				success : false,
			},
			sucursalesDefault : [],
			sucursales : [],
			lista : [],
			sucursal_id:'',
			codigo:'',
			nombre :'',
			telefono:'',
			direccion:'',
			action : '',
			message : '',
			search : '',
			openInfo:false,
		};
		this.sesionShantal = JSON.parse( localStorage.getItem('sesion') );
	}
	eventOpenModal = (id) => {
		let sucursal=null;
		if( id > 0){
			sucursal = this.state.sucursales.find(e=>e.id === id);
			this.setState(state=>({
				sucursal_id : sucursal.id,
				codigo : sucursal.codigo,
				nombre : sucursal.nombre,
				telefono : sucursal.telefono,
				direccion : sucursal.direccion,
			}));
		}
		this.setState(state=>({
			openModal : !state.openModal
		}));
	}
	// Abre modal para editar
	openModalView = (id) => {
		const sucursal = this.state.sucursales.find(e=>e.id===id);
		const openInfo = !this.state.openInfo;
		this.setState({openInfo, sucursal});
	}
	closeModalInfo = () => {
		const openInfo = !this.state.openInfo;
		const sucursal = {};
		this.setState({openInfo, sucursal});
	}
	windowCloseUpdate = () => {
		const action = '';
		const display = { success : !this.state.display.success}
		this.setState({display,action});
	}
	closeModal = () => {
		this.setState(state=>({
			sucursal_id : '',
			codigo : '',
			nombre : '',
			telefono : '',
			direccion : '',
		}));
		this.setState(state=>({
			openModal : !state.openModal
		}));
	}
	closeModalDelete = () => {
		this.setState(state=>{
			const display = { delete : !state.display.delete}
			return{
				display,
				nombre:'',
				sucursal_id :''
			}
		});
	}
	componentDidMount = () => {
		fetch(window.$api+'/sucursales')
		.then(res=>res.json()).then(
			sucursales =>{ 
				const sucursalesDefault = JSON.parse( JSON.stringify(sucursales) );
				this.setState({sucursales,sucursalesDefault}); 
			},
			error=>{console.log(error);}
		);
	}
	config = (method, body) => {
		return {
			method : method,
			body : JSON.stringify( body ),
			headers : {
				'Content-Type': 'application/json'
			}
		};
	}
	inputHandler = (e) => {
		let data = e.target;
		this.setState(state=>({
			[data.name] : data.value
		}));
	}
	searchHandler = (e) =>{
		let search = e.target.value;
		let sucursales = [];
		sucursales = this.state.sucursalesDefault.filter(sucursal=>{
				const itemData = sucursal.nombre.toUpperCase();
				const textData = search.toUpperCase();
				return itemData.indexOf(textData) > -1
		});
		this.setState({search,sucursales});
	}

	deleteItem = (id) => {
		this.setState(e=>{
				return{
					display : { load : !e.display.load }
				}
		});
		fetch(
			window.$api+'/sucursal/'+ this.state.sucursal_id,
			{ method : 'DELETE' }
		).then(res=>res.json()).then(
			res=>{
				const sucursal_id = "";
				const nombre = "";
				if( res.band === true ){
					this.setState(state=>{
						const display = { 
							load : !state.display.load,
							delete : !state.display.delete,
							success : !this.state.display.success
						}
						const sucursales = state.sucursales.filter((item) => item.id !== this.state.sucursal_id);
						const sucursalesDefault = JSON.parse( JSON.stringify(sucursales) );
						const action = 'success';
						return{
							sucursalesDefault,
							sucursales,
							display,
							sucursal_id,
							nombre,
							action
						}
					});
				}else{
					this.setState(state=>{
						const display = { 
							load : !state.display.load,
							success : !state.display.success
						}
						const action = 'error';
						const message = res.message;
						return{
							display,
							sucursal_id,
							nombre,
							action,
							message
						}
					});
				}
			},
			error=>{
				const display = { 
					load : !this.state.display.load
				}
				this.setState({display});
				console.log('ERROR');
			}
		);
	}
	onRemoveItem = (id) => {

		this.setState(state=>{
			const display = { delete : !state.display.delete}
			const sucursal_id = id;
			return{
				display,
				sucursal_id
			}
		});
		const _sucursal = this.state.sucursales.find(item=>item.id===id);
		this.setState({nombre:_sucursal.nombre});
	}
	mySubmitHandler = (e) =>{
		e.preventDefault();
		if( this.state.sucursal_id > 0 ){
			this.setState(e=>{
				return{
					display : { load : !e.display.load }
				}
			});
			
				fetch(
					window.$api+'/sucursal/'+this.state.sucursal_id,
					this.config('UPDATE', {
						nombre : this.state.nombre,
						direccion : this.state.direccion,
						telefono : this.state.telefono
					})
				).then(res=>res.json())
				.then(res=>{
					this.setState(state=>{
						const sucursales = state.sucursales.map((item)=>{
							if(item.id === state.sucursal_id){
								item.nombre = state.nombre;
								item.direccion = state.direccion;
								item.telefono = state.telefono;
								return item;
							}else{
								return item;
							}
						});
						const sucursalesDefault = JSON.parse( JSON.stringify(sucursales) );
						return {
							sucursalesDefault,
							sucursales,
							sucursal_id:"",
							codigo : "",
							nombre : "",
							direccion : "",
							telefono : "",
							openModal : !state.openModal,
							action : 'success',
							display : { load : !state.display.load, success : !state.display.success }
						};
					});
					this.setState({load:!this.state.load});
				}).catch(error=>{
					console.error(error);
				})

		}else{
			if( this.state.nombre !== '' ){
				const display = !this.state.display.load;
				this.setState({display});
				const setup = {
					method : 'POST',
					headers : { 'Content-Type': 'application/json' },
					body : JSON.stringify({
						nombre : this.state.nombre,
						direccion : this.state.direccion,
						telefono : this.state.telefono
					})
				};
				let sucursales = JSON.parse( JSON.stringify( this.state.sucursales ) );
				fetch(window.$api+'/sucursal',setup)
				.then(res=>res.json()).then(sucursal=>{
					sucursales.push({
						id : sucursal.id,
						nombre : sucursal.nombre,
						direccion : sucursal.direccion,
						telefono : sucursal.telefono
					});
					const sucursalesDefault = sucursales;
				
					this.setState(state=>{
							return {
								sucursalesDefault,
								sucursales,
								nombre : "",
								action : "success",
								direccion : "",
								telefono : "",
								display : { load : !state.display.load, success : !state.display.success },
								openModal : !state.openModal
							};
						});
					},
					error=>{console.log(error.response);}
				);
			}else{
				toast.warning('Formulario incompleto');
			}
		}
	}
	render = () => {
		return(
			<div className="wrap-module">
			<h1>Sucursal</h1>
			<div className="wrap-content">
				<SearchBar 
					searchHandler={this.searchHandler} 
					openModal={this.eventOpenModal} 
					text={'sucursal'}
				/>
				<table className="listTable">
					<thead>
						<tr>
							<th className="sucursal">Sucursal</th>
							<th className="tipo">Teléfono</th>
							<th className="tipo">Encabezado para ticket</th>
							<th className="operaciones">&nbsp;</th>
						</tr>
					</thead>
					{	this.state.sucursales.length > 0 && 
						<Items
							sucursales={this.state.sucursales} 
							onRemoveItem={this.onRemoveItem} 
							openmodal={this.eventOpenModal}
							openModalView={this.openModalView}
							sesion={this.sesionShantal}
						/>
					}
				</table>
			</div>
			<div className={this.state.openModal ? 'overlay show':'overlay'}>
				<form onSubmit={this.mySubmitHandler} className="content">
					<div className="modal_header">
						<h5>{ this.state.sucursal_id > 0 ? 'Editar' : 'Nuevo' }</h5>
						<span className="close-pop-up" onClick={this.closeModal}>x</span>
					</div>
					<div className="modal_body">
						<label>
							<input type="text" onChange={this.inputHandler} name="nombre" value={this.state.nombre} placeholder=" "/>
							<span>Sucursal</span>
						</label>
						<label>
							<input type="text" onChange={this.inputHandler} name="telefono" value={this.state.telefono} placeholder=" "/>
							<span>Teléfono</span>
						</label>
						<label>
							<textarea onChange={this.inputHandler} name="direccion" value={this.state.direccion} placeholder=" "/>
							<span className="fixed">Encabezado para ticket</span>
						</label>
						<div className="text-center">
							<button type="submit" className="btn btn-green">Guardar</button>
						</div>
					</div>
				</form>
			</div>
			<Load display={this.state.display.load}/>
			{ this.state.action !== '' &&
				<Success 
					display={this.state.display.success} 
					action={this.state.action}
					message={this.state.message}
					windowCloseUpdate={this.windowCloseUpdate} 
				/>
			}
			<DeleteItem 
				display={this.state.display.delete} 
				name={this.state.nombre} 
				closeModalDelete={this.closeModalDelete}
				deleteItem={this.deleteItem}
			/>
			{ this.state.openInfo &&
				<Info
					display={this.state.openInfo}
					sucursal={this.state.sucursal}
					closeModal={this.closeModalInfo}
				/>
			}
		</div>
		)
	}
}
export default Sucursal;